import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import {
  updateDates,
  search,
  toggleExcludeMoyensAnnexes,
  updateParties,
  filterOnSpecificArticleVersion,
  toggleAggregation,
  updateLawyerFilter,
  updateEnterpriseFilter,
} from '../../../../state/actions';
import { StateType } from '../../../../../state/state.types';
import {
  buildDateFilter,
  buildAggregationFilters,
  buildPartiesFilter,
  buildLegislationFilter,
} from './filterBoxUtils';

const mapState = (state: StateType) => {
  const {
    dates,
    excludeMoyensAnnexes,
    parties,
    filterOnSpecificArticleVersion: isLegislationFilterOn,
    lid,
    eid,
    aggregationsPaths,
  } = state.queryParams;
  const { enterprise, professional, law } = state.results.snippets;
  return {
    enterprise: eid && enterprise ? enterprise : null,
    lawyer: lid && professional ? professional : null,
    legislation:
      isLegislationFilterOn && law ? buildLegislationFilter(law) : null,
    date: dates ? buildDateFilter(dates) : null,
    excludeMoyensAnnexes,
    aggregations: [
      ...buildAggregationFilters(aggregationsPaths, 'ville'),
      ...buildAggregationFilters(aggregationsPaths, 'juridiction'),
      ...buildAggregationFilters(aggregationsPaths, 'domaine'),
      ...buildAggregationFilters(aggregationsPaths, 'publi'),
      ...buildAggregationFilters(aggregationsPaths, 'solution'),
      ...buildAggregationFilters(aggregationsPaths, 'publisher'),
      ...buildAggregationFilters(aggregationsPaths, 'textCode'),
      ...buildAggregationFilters(aggregationsPaths, 'otherLegislation'),
      ...buildAggregationFilters(aggregationsPaths, 'collectiveAgreements'),
    ],
    parties: parties ? buildPartiesFilter(parties) : null,
  };
};

const mapDispatch = (dispatch: ThunkDispatch<StateType, {}, AnyAction>) => ({
  removeDateFilter() {
    dispatch(updateDates({}));
    dispatch(search({ reason: 'faceted' }));
  },
  removeMoyensAnnexesFilter() {
    dispatch(toggleExcludeMoyensAnnexes());
    dispatch(search({ reason: 'exclude' }));
  },
  removePartiesFilter() {
    dispatch(updateParties({}));
    dispatch(search({ reason: 'faceted' }));
  },
  removeLegislationFilter() {
    dispatch(filterOnSpecificArticleVersion());
    dispatch(search({ reason: 'restrict-from-snippet' }));
  },
  removeAggregationFilter(path: Array<string>) {
    dispatch(toggleAggregation(path, false));
    dispatch(search({ reason: 'faceted' }));
  },
  removeLawyerFilter() {
    dispatch(updateLawyerFilter(undefined));
    dispatch(search({ reason: 'lawyerFilter' }));
  },
  removeEnterpriseFilter() {
    dispatch(updateEnterpriseFilter(undefined));
    dispatch(search({ reason: 'enterpriseFilter' }));
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
